module.exports = __webpack_public_path__ + "static/img/gyl3.f02d986.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gyl3.png
// module id = YK5W
// module chunks = 1